import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.b8{gap:8px;}.ssr-plugin'
import '.i8{height:120px;}.ssr-plugin'
import '.i9{vertical-align:center;}.ssr-plugin'
import '.ia{font-size:0px;}.ssr-plugin'
import '.fj{padding:8px;}.ssr-plugin'
import '.gd{overflow-y:auto;}.ssr-plugin'
import '.ge{overflow-x:hidden;}.ssr-plugin'
import '.ib{max-width:100%;}.ssr-plugin'
import '.f4{display:inline-flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.fl{padding:4px;}.ssr-plugin'
import '.ic{cursor:not-allowed;}.ssr-plugin'
import '.bn{margin-bottom:8px;}.ssr-plugin'
import '.ay{margin-right:8px;}.ssr-plugin'
import '.fk{outline:none;}.ssr-plugin'
import '.hm{width:2px;}.ssr-plugin'
import '.o{height:100%;}.ssr-plugin'
import '.ey{flex-shrink:0;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.a3{gap:4px;}.ssr-plugin'
import { useState } from 'react'
import { Button } from '../Button/index.js'
import { Modal } from '../Modal/index.js'
import { TextInput } from '../TextInput/index.js'
import { SelectInput, SelectInputProps } from '../SelectInput/index.js'
import { NumberInput } from '../NumberInput/index.js'
import { DateInput } from '../DateInput/index.js'
import { Icon, IconProps } from '../Icon/index.js'
import { Text } from '../Text/index.js'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { styled } from 'inlines'
import { LabelDescription } from '../LabelDescription/index.js'

type StringTagInputProps = {
  variant: 'string'
  value?: string[]
  onChange: (value: string[]) => void
}
type NumberTagInputProps = {
  variant: 'number'
  value?: number[]
  onChange: (value: number[]) => void
}
type BooleanTagInputProps = {
  variant: 'boolean'
  value?: boolean[]
  onChange: (value: boolean[]) => void
}
type EnumTagInputProps = {
  variant: 'enum'
  value?: string[]
  onChange: (value: string[]) => void
  options: SelectInputProps['options']
}
type DateTimeTagInputProps = {
  variant: 'date-time'
  value?: number[]
  onChange: (value: number[]) => void
}

type TagInputProps = (
  | StringTagInputProps
  | NumberTagInputProps
  | BooleanTagInputProps
  | EnumTagInputProps
  | DateTimeTagInputProps
) & {
  disabled?: boolean
  label?: string
  description?: string
  error?: boolean
  errorMessage?: string
  placeholder?: string
  placeholderIcon?: IconProps['variant']
}

const TagInput = (props: TagInputProps) => {
  const value = props.value ?? []
  const [editIndex, setEditIndex] = useState<number>()
  const [editValue, setEditValue] = useState<string | number | boolean>()

  return (
    <LabelDescription
      label={props.label}
      description={props.description}
      error={props.error && props.errorMessage}
    >
      <div className="a i h b8"
      >
        <styled.div className="h i8 i9 ia fj gd ge"
          style={{
            borderRadius: radius[12],
            border: `1px solid ${colors.neutral20Adjusted}`,
            ...(props.error && {
              border: `1px solid ${colors.red80}`,
            }),
            ...(props.disabled && {
              cursor: 'not-allowed',
              color: colors.neutral20,
              background: colors.neutral5,
              border: `1px solid transparent`,
            }),
          }}
        >
          {Boolean(value?.length) &&
            value.map((val, index) => (
              <styled.div className="ib f4 d fl ic bn ay fk"
                onClick={() => {
                  if (props.disabled) return
                  setEditIndex(index)
                  setEditValue(val)
                }}
                style={{
                  borderRadius: radius[6],
                  background: colors.neutral10Adjusted,
                  color: colors.neutral20,
                  ...(!props.disabled && {
                    color: colors.neutral80,
                    cursor: 'pointer',
                    '&:hover': {
                      background: colors.neutral20Adjusted,
                    },
                  }),
                }}
              >
                <div className="hm o ey"
                />
                <Text singleLine variant="subtext-medium" color="inherit">
                  {props.variant === 'date-time'
                    ? new Date(val as number).toLocaleString()
                    : val.toString()}
                </Text>
                <div className="hm o ey"
                />
                <styled.div className="ey a d c ic"
                  onClick={(e) => {
                    if (props.disabled) return
                    e.stopPropagation()
                    props.onChange(value.filter((_, i) => i !== index) as any)
                  }}
                  style={{
                    borderRadius: radius[6],
                    ...(!props.disabled && {
                      cursor: 'pointer',
                      '&:hover': {
                        background: colors.neutral20Adjusted,
                      },
                    }),
                  }}
                >
                  <Icon variant="close" size="small" />
                </styled.div>
              </styled.div>
            ))}
          {Boolean(!value?.length) && (
            <div className="h o c d a i a3"
              style={{
                color: colors.neutral60,
              }}
            >
              {props.placeholderIcon && (
                <Icon variant={props.placeholderIcon} />
              )}
              {props.placeholder && (
                <Text variant="subtext-medium" color="inherit">
                  {props.placeholder}
                </Text>
              )}
            </div>
          )}
        </styled.div>

        <div className="a b8">
          <Modal size="small">
            <Modal.Trigger>
              <Button
                leadIcon="add"
                variant="border"
                onClick={() => {
                  setEditIndex(undefined)
                  setEditValue(undefined)
                }}
                disabled={props.disabled}
              >
                Add {props.variant}
              </Button>
            </Modal.Trigger>
            <Modal.Content>
              <Modal.Header
                title={
                  typeof editIndex === 'number'
                    ? `Edit ${props.variant}`
                    : `Add ${props.variant}`
                }
              />
              <Modal.Body>
                {props.variant === 'string' && (
                  <TextInput
                    value={editValue as string}
                    onChange={setEditValue}
                    autoFocus
                  />
                )}
                {props.variant === 'number' && (
                  <NumberInput
                    value={editValue as number}
                    onChange={setEditValue}
                    autoFocus
                  />
                )}
                {props.variant === 'boolean' && (
                  <SelectInput
                    value={editValue as boolean}
                    onChange={setEditValue}
                    options={[
                      { value: true, label: 'True' },
                      { value: false, label: 'False' },
                    ]}
                  />
                )}
                {props.variant === 'enum' && (
                  <SelectInput
                    value={editValue as string}
                    onChange={setEditValue}
                    options={props.options}
                  />
                )}
                {props.variant === 'date-time' && (
                  <DateInput
                    value={editValue as number}
                    onChange={setEditValue}
                    variant="date-time"
                  />
                )}
              </Modal.Body>
              <Modal.Footer>
                <div style={{ display: 'flex', gap: 8 }}>
                  <Button
                    variant="border"
                    onClick={() => Modal.Close()}
                    keyHint="Esc"
                  >
                    Cancel
                  </Button>
                  <Button
                    keyHint="Enter"
                    disabled={typeof editValue === 'undefined'}
                    onClick={() => {
                      if (typeof editIndex !== 'undefined') {
                        props.onChange(
                          value.map(
                            (e, i) => (i === editIndex ? editValue : e) as any,
                          ),
                        )
                      } else {
                        props.onChange([...value, editValue as any])
                      }
                      Modal.Close()
                      setEditValue(undefined)
                      setEditIndex(undefined)
                    }}
                  >
                    {editIndex ? 'Save' : 'Add'}
                  </Button>
                </div>
              </Modal.Footer>
            </Modal.Content>
          </Modal>
        </div>
      </div>
    </LabelDescription>
  )
}

export { TagInput }
export type { TagInputProps, EnumTagInputProps }
